import {useState, useEffect, useRef, Fragment, memo, useContext} from "react"
import {SocketContext} from '@src/utility/context/Socket'
import {Link} from "react-router-dom"
import Avatar from "@components/avatar"
import {useDispatch, useSelector} from "react-redux"
import {
    storeMessagesInRedux,
    addBrandContactsInRedux,
    sendMsgRD,
    uploadMediaToserver,
    recieveMsg,
    sendBroadcastMsg,
    myRdList,
    allRdList,
    archiveConversation,
    unarchiveConversation,
    markConversationUnread
} from "./store/actions"
import {
    getFavoriteFolders,
    getFavoriteRDProfiles
} from '@src/redux/actions/brandsDashboard'
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import CustomAvatar from '@src/views/components/CustomAvatar'
import {
    MessageSquare,
    Paperclip,
    FileText,
    Heart,
    ArrowLeftCircle,
    File,
    ChevronLeft,
    Send,
    Image,
    X,
    MessageCircle,
    Info,
    Users,
    User,
    MoreVertical,
    Mail,
    Clock,
    Plus
} from "react-feather"
import {
    Form,
    Input,
    Label,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    CustomInput,
    Card,
    CardBody,
    Row,
    Col,
    Spinner,
    UncontrolledButtonDropdown,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Alert
} from "reactstrap"
import { ArchiveIcon, UnarchiveIcon } from '@src/views/components/ArchiveIcons'
import {allowedFiles, allowedFilesErrorMessages} from '@src/utility/Utils'
import BlankProfile from "@src/assets/images/avatars/avatar-blank.png"
import {Slide, toast} from "react-toastify"
import {getGoalsAttributes} from '@src/views/brands/nutritionExperts/store/actions'
import {
    rdGroupList,
    rdGroupListReset
} from "@src/redux/actions/BrandActions"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import draftToHtml from "draftjs-to-html"
import {ContentState, convertToRaw, EditorState} from "draft-js"
import {Editor} from "react-draft-wysiwyg"
import '@styles/react/libs/editor/editor.scss'
import '@styles/base/plugins/forms/form-quill-editor.scss'
import htmlToDraft from "html-to-draftjs"
import {PropTypes} from "prop-types"
import MsgTemplates from '@src/views/components/MsgTemplates'
import useMessageFollowUp from '@src/views/components/hooks/useMessageFollowUp'

const ChatLog = (props) => {
    const sweetAlert = withReactContent(Swal)

    const ps = useRef([])
    const {
        handleUser,
        handleUserSidebarRight,
        handleSidebar,
        store,
        userSidebarLeft,
        user,
        selectedUserID,
        selectedUserBrandChat,
        selectedContactDetail,
        currentUser,
        onTabChange,
        activeTab
    } = props

    const brandChatStoreSlice = useSelector((state) => state.chatBrands)

    const brandsDashboardStoreSlice = useSelector(store => store.brandsDashboardSlice)

    const {
        rdGroupListLoading,
        rdGroupListData,
        rdGroupListError
    } = useSelector(state => state.brandReducer)

    const chatArea = useRef(null)
    const dispatch = useDispatch()
    const socket = useContext(SocketContext)

    const chatMessages = selectedUserBrandChat?.data || []
    const currentUserId = currentUser?.chat_id || currentUser?.id
    const otherUserChatId = selectedContactDetail?.chat_user
    const {showFollowUp, daysSince, isLongWait, lastMessageDate} = useMessageFollowUp(chatMessages, currentUserId, otherUserChatId)

    const isThreadArchived = activeTab === 'archive' ||
        selectedContactDetail?.is_archived === true ||
        selectedContactDetail?.is_archived === 1 ||
        selectedContactDetail?.is_archived === '1' ||
        selectedContactDetail?.is_archived === 'true'

    // Helper: format WhatsApp-style timestamp — always 12-hour AM/PM
    const formatMsgTime = (timezone) => {
        if (!timezone) return ''
        const d = new Date(timezone)
        if (isNaN(d.getTime())) return timezone

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())
        const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })

        if (msgDate.getTime() === today.getTime()) {
            return `Today, ${timeStr}`
        } else if (msgDate.getTime() === yesterday.getTime()) {
            return `Yesterday, ${timeStr}`
        } else {
            const dateStr = d.toLocaleDateString([], { month: 'short', day: 'numeric' })
            return `${dateStr}, ${timeStr}`
        }
    }

    // Helper: format month + year for long-wait banner
    const formatMonthYear = (date) => {
        if (!date) return ''
        return date.toLocaleDateString([], {month: 'long', year: 'numeric'})
    }

    // Helper: format header subtitle status
    const getHeaderSubtitle = () => {
        if (!selectedContactDetail) return null
        if (selectedContactDetail.is_mass_group || selectedContactDetail.user_type === 'mass') {
            return <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Broadcast log</small>
        }
        if (selectedContactDetail?.status === 0 || selectedContactDetail?.status === '0' || selectedContactDetail?.is_active === 0 || selectedContactDetail?.is_active === '0') {
            return <small className='text-danger text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Account is blocked</small>
        }
        const lastMsg = (chatMessages && chatMessages.length > 0) ? chatMessages[chatMessages.length - 1] : null
        const rawDate = lastMsg?.created_at || lastMsg?.timezone || selectedContactDetail?.last_message_created_at || selectedContactDetail?.created_at || selectedContactDetail?.last_message_timezone || selectedContactDetail?.timezone || selectedContactDetail?.last_message_time
        if (!rawDate) {
            return <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>No messages yet</small>
        }
        const dateObj = new Date(rawDate)
        const isValidDate = !isNaN(dateObj.getTime())
        if (!isValidDate) {
            return null
        }

        const timeStr = dateObj.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })
        const dateStr = dateObj.toLocaleDateString([], { day: 'numeric', month: 'short' })
        const subtitleText = `Last message · ${dateStr}, ${timeStr}`

        return (
            <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>
                {subtitleText}
            </small>
        )
    }

    // ** State
    const [msg, setMsg] = useState("")
    const [questate, setQueState] = useState({inQueFilePreview: "", inQueFile: ""})
    const [selectedFile, setSelectedFile] = useState(null)
    const [isFilePicked, setIsFilePicked] = useState(false)
    const [isOpenTempleteModal, setIsOpenTempleteModal] = useState(false)
    const [isOpenBroadcastModal, setIsOpenBroadcastModal] = useState(false)
    const [broadcastMessage, setBroadcastMessage] = useState('')
    const [selectedBroadcastContacts, setSelectedBraodcastContacts] = useState([])
    const [broadCastRDsList, setBroadCastRDsList] = useState([])
    const [broadCastRDsListLoading, setBroadCastRDsListLoading] = useState(false)
    const [fileUploadError, setFileUploadError] = useState(false)
    const [checkAllVal, setCheckAllVal] = useState(false)
    const [showFav, setShowFav] = useState(false)
    const [favFolderList, setFavFolderList] = useState(null)
    const [favFolderId, setFavFolderId] = useState(null)
    const [favFolderTitle, setFavFolderTitle] = useState(null)
    const [backToFav, setBackToFav] = useState(false)
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [selectedRds, setSelectedRds] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('')
    const [broadCastSendLoader, setBroadCastSendLoader] = useState(false)
    const [broadCastResMsg, setBroadCastResMsg] = useState(null)
    const [broadCastResStatus, setBroadCastResStatus] = useState(null)
    const [sendMsgLoader, setSendMsgLoader] = useState(false)
    const [showGroups, setShowGroups] = useState(false)
    const [groupData, setGroupData] = useState({speciality: [], industry: [], characteristics: []})
    const [selectedGroupLabels, setSelectedGroupLabels] = useState([])
    const [massMsgEditorState, setMassMsgEditorState] = useState(null)
    const [msgEditorState, setMsgEditorState] = useState(null)
    const [templateType, setTemplateType] = useState(null)
    const [openTemplatesModal, setOpenTemplatesModal] = useState(false)
    const [recipientSearch, setRecipientSearch] = useState('')
    const [showTemplateBar, setShowTemplateBar] = useState(false)
    const templateBarRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (templateBarRef.current && !templateBarRef.current.contains(event.target)) {
                setShowTemplateBar(false)
            }
        }
        if (showTemplateBar) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('touchstart', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [showTemplateBar])

    const scrollToBottom = () => {
        if (chatArea.current) {
            chatArea.current.scrollTop = chatArea.current.scrollHeight
        }
    }

    useEffect(() => {
        socket.on("connect", (error) => {
            if (error) {
                alert(error)
            }
        })

        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        socket.emit("join", user, (error) => {
        })

        if (selectedUserID) {
            const selectedChatRdContactRaw = localStorage.getItem('selectedChatRd')
            const selectedChatRdContact = selectedChatRdContactRaw ? JSON.parse(selectedChatRdContactRaw) : {}
            dispatch(addBrandContactsInRedux({chat_user: parseInt(selectedUserID), ...selectedChatRdContact}))
        }

        dispatch(getGoalsAttributes())
    }, [])

    useEffect(() => {
        if (selectedContactDetail) {
            scrollToBottom()
        }

        if (!!brandChatStoreSlice?.braodcastContactList) {
            setBroadCastRDsListLoading(false)
            setBroadCastRDsList(brandChatStoreSlice.braodcastContactList.data)
        }

        if (!!brandChatStoreSlice?.broadcastResponse) {
            if (brandChatStoreSlice?.broadcastResponse?.status === true) {
                setBroadCastResMsg(brandChatStoreSlice?.broadcastResponse?.msg)
                setBroadCastResStatus(brandChatStoreSlice?.broadcastResponse?.status)
                setBroadCastSendLoader(false)
                setIsOpenBroadcastModal(false)
                setSelectedBraodcastContacts([])
                setCheckAllVal(false)
                setBroadCastRDsList([])
                dispatch({type: 'CLEAT_BROADCAST_LIST'})
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
                dispatch({type: 'CLEAR_CHAT_CONTENT_ON_LOAD'})
                dispatch({type: 'CLEAR_CHAT_CONTACT_ON_LOAD'})
                setTimeout(() => {
                    setShowPreviewModal(false)
                    setBroadCastResMsg(null)
                    setBroadCastResStatus(null)
                    setSelectedRds([])
                    setBroadcastMessage("")
                    setMassMsgEditorState(null)
                }, 5000)
            }

            if (brandChatStoreSlice?.broadcastResponse?.config) {
                sweetAlert.fire({
                    title: 'Error!',
                    icon: 'error',
                    html: `<p>Status: ${brandChatStoreSlice?.broadcastResponse?.response?.status || 500}</p><p>${JSON.stringify(brandChatStoreSlice?.broadcastResponse?.response?.data ?? "Internal Server Error")}</p>`,
                    allowOutsideClick: false,
                    showCancelButton: false
                })
                setBroadCastSendLoader(false)
                dispatch({type: 'CLEAT_BROADCAST_SUCCESS_RESPONSE'})
            }
        }

        if (brandChatStoreSlice?.sendMessageResponse) {
            setSendMsgLoader(false)
            if (brandChatStoreSlice?.sendMessageResponse.status) {
                toast.success(
                    <Fragment>
                        <div className='toastify-header'>
                            <div className='title-wrapper'>
                                <Avatar size='sm' color='success' icon={<MessageSquare size={12}/>}/>
                                <h6 className='toast-title font-weight-bold'>Success</h6>
                            </div>
                        </div>
                        <div className='toastify-body'>
                            <span>{brandChatStoreSlice?.sendMessageResponse?.msg}</span>
                        </div>
                    </Fragment>, {transition: Slide, hideProgressBar: true, autoClose: 5000})
            } else {
                toast.error(<Fragment>{brandChatStoreSlice?.sendMessageResponse?.msg}</Fragment>, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 5000
                })
            }
            setMsg("")
            setMsgEditorState(null)
            dispatch({type: "SEND_MSG_NULL_RESPONSE"})
        }

        const error = brandChatStoreSlice?.chatLoadError?.response?.status
        if (error && error !== 401) {
            dispatch({type: "BRAND_CHAT_LOAD_ERROR_RESET"})
            dispatch({type: "SELECTED_CHAT_LOADER_RESET"})
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
        }
    }, [brandChatStoreSlice])

    useEffect(() => {
        socket.on('new-user-message', (data) => {
            const receivedMessage = {
                message: data.data.message,
                media: data.data.media,
                from_user_id: data.data.from_user_id,
                to_user_id: data.data.to_user_id
            }
            // console.log('new-user-message data', data)
            // console.log('new-user-message', receivedMessage)
            dispatch(recieveMsg(receivedMessage))
        })
    }, [])

    useEffect(() => {
        if (brandsDashboardStoreSlice?.favoriteFoldersRes) {
            setBroadCastRDsListLoading(false)
            setFavFolderList(brandsDashboardStoreSlice?.favoriteFoldersRes?.data)
        }

        if (brandsDashboardStoreSlice?.favoriteRDProfilesRes) {
            setBroadCastRDsListLoading(false)
            const data = brandsDashboardStoreSlice?.favoriteRDProfilesRes?.data.map((item) => {
                return {
                    user_id: item.id,
                    profile_img: item.profile_img,
                    name: item.name,
                    is_favorite: null,
                    folder_title: null
                }
            })
            setBroadCastRDsList(data)
        }
    }, [brandsDashboardStoreSlice])

    useEffect(() => {
        if (rdGroupListData?.data) {
            setBroadCastRDsList(rdGroupListData?.data)
            setSelectedBraodcastContacts(rdGroupListData?.data.map(item => item?.user_id))
            setSelectedRds(rdGroupListData?.data.map(item => item?.name))
        }
    }, [rdGroupListData])

    const getBase64 = (img, callback) => {
        if (img) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        }
    }

    const handleSendMsg = (e) => {
        e.preventDefault()
        setSendMsgLoader(true)
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const date = new Date()
        const objTest = {
            chat: [],
            selectedRd: selectedUserID
        }
        const msgObj = {
            message: msg,
            from_user_id: user.chat_id,
            to_user_id: receiver_id,
            timezone: date.toString()
        }
        objTest.chat.push(msgObj)
        dispatch(storeMessagesInRedux(objTest))
        dispatch(sendMsgRD(msgObj))
        socket.emit("new-message", msgObj)
        if (selectedFile) {
            const media = {
                to_user_id: receiver_id,
                file: selectedFile,
                from_user_id: user.chat_id,
                socket
            }
            dispatch(uploadMediaToserver(media))
            setIsFilePicked(false)
            setSelectedFile('')
            setQueState(prevState => ({
                ...prevState,
                inQueFilePreview: '',
                inQueFile: ''
            }))
        }
    }

    const changeHandler = (event) => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedContactDetail.chat_user
        const file = event.target.files[0]
        setFileUploadError(false)
        if (!file) return
        if (allowedFiles().includes(file.name?.split('.').pop().toLowerCase())) {
            setSelectedFile(file)

            getBase64(file, imageUrl => {
                // console.log('inQueFilePreview', imageUrl)
                setQueState(prevState => ({
                    ...prevState,
                    inQueFilePreview: imageUrl,
                    inQueFile: file
                }))
            })
            setIsFilePicked(true)
        } else {
            setSelectedFile(null)
            setQueState({
                inQueFilePreview: '',
                inQueFile: ''
            })
            setFileUploadError(true)
        }
    }

    const appendTemplate = (item) => {
        const content = htmlToDraft(item.template)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        const createContent = EditorState.createWithContent(contentState)
        if (item?.type === 'message') {
            setMsgEditorState(createContent)
            setMsg(item.template)
        } else {
            setMassMsgEditorState(createContent)
            setBroadcastMessage(item.template)
        }
    }

    const getRdList = (option) => {
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setCheckAllVal(false)
        setFavFolderList(null)
        setBackToFav(false)
        setSelectedRds([])
        setSelectedGroupLabels([])
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        dispatch({type: "CLEAR_FAV_PROFILES"})
        setSelectedRadio(option)
        if (option === 'my_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(myRdList())
        } else if (option === 'all_rds') {
            setBroadCastRDsListLoading(true)
            setShowFav(false)
            setShowGroups(false)
            dispatch(allRdList())
        } else if (option === 'groups') {
            setBroadCastRDsListLoading(false)
            setShowFav(false)
            setShowGroups(true)
        } else if (option === 'favourites') {
            setBroadCastRDsListLoading(true)
            setShowFav(true)
            setShowGroups(false)
            const API_URL = process.env.REACT_APP_BASEURL
            dispatch(getFavoriteFolders(true, `${API_URL}brand/load-folder-list?list=all`))
        }
    }

    const handleSelectBroadCastingContact = (contact) => {
        setCheckAllVal(false)
        let list = [...selectedBroadcastContacts]
        let names = [...selectedRds]
        if (!list.includes(contact.user_id)) {
            list.push(contact.user_id)
            names.push(contact.name)
        } else {
            list = list.filter(id => id !== contact.user_id)
            names = names.filter(name => name !== contact.name)
        }
        setSelectedBraodcastContacts(list)
        setSelectedRds(names)
    }

    const computeMassMessageTitle = () => {
        const count = selectedBroadcastContacts.length
        if (selectedRadio === 'my_rds') {
            if (checkAllVal || (broadCastRDsList.length > 0 && count === broadCastRDsList.length)) {
                return 'Mass Message to My RDs'
            }
            return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
        }
        if (selectedRadio === 'all_rds') {
            if (checkAllVal || (broadCastRDsList.length > 0 && count === broadCastRDsList.length)) {
                return 'Mass Message to All RDs'
            }
            return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
        }
        if (selectedRadio === 'favourites' && favFolderTitle) {
            const cleanFolder = favFolderTitle.trim()
            if (cleanFolder.toLowerCase().endsWith('rds') || cleanFolder.toLowerCase().endsWith('rd')) {
                return `Mass Message to ${cleanFolder}`
            }
            return `Mass Message to ${cleanFolder} RDs`
        }
        if (selectedRadio === 'groups' && selectedGroupLabels && selectedGroupLabels.length > 0) {
            if (selectedGroupLabels.length === 1) {
                return `Mass Message to ${selectedGroupLabels[0]} RDs`
            }
            if (selectedGroupLabels.length === 2) {
                return `Mass Message to ${selectedGroupLabels[0]} and ${selectedGroupLabels[1]} RDs`
            }
            if (selectedGroupLabels.length === 3) {
                return `Mass Message to ${selectedGroupLabels[0]}, ${selectedGroupLabels[1]} and ${selectedGroupLabels[2]} RDs`
            }
            return `Mass Message to ${count} Filtered RDs`
        }
        return `Mass Message to ${count} Selected RD${count === 1 ? '' : 's'}`
    }

    const sendBroadcastMessage = () => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const date = new Date()
        const targetTitle = computeMassMessageTitle()
        const msgObj = {
            message: broadcastMessage,
            from_user_id: user.chat_id,
            role: "rd",
            socket,
            to_users: selectedBroadcastContacts,
            target_title: targetTitle,
            mass_title: targetTitle,
            timezone: date.toString()
        }
        setBroadCastSendLoader(true)
        dispatch(sendBroadcastMsg(msgObj))
    }

    const handleFollowUpClick = () => {
        const defaultFollowUp = '<p>Hi! Just following up on my previous message to see if you had any questions.</p>'
        const content = htmlToDraft(defaultFollowUp)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        setMsgEditorState(EditorState.createWithContent(contentState))
        setMsg(defaultFollowUp)
    }

    // Helper: extract date string key for date divider grouping
    const getDateKey = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }

    // Helper: format center date divider banner (e.g. Jun 17, 2026 / Today / Yesterday)
    const formatDateDivider = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return rawTime

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())

        if (msgDate.getTime() === today.getTime()) {
            return 'Today'
        }
        if (msgDate.getTime() === yesterday.getTime()) {
            return 'Yesterday'
        }
        return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
    }

    // Helper: format time only (e.g. 9:14 AM or 11:32 AM)
    const formatTimeOnly = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    }

    const renderChats = () => {
        const messages = selectedUserBrandChat?.data
        if (!messages || messages.length === 0) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100%', minHeight: '200px', color: '#aaa'}}>
                    <MessageSquare size={40} style={{marginBottom: '10px', opacity: 0.4}}/>
                    <p style={{fontSize: '0.9rem'}}>No messages yet. Start the conversation!</p>
                </div>
            )
        }
        return messages.map((item, index) => {
            const otherId = parseInt(selectedContactDetail?.chat_user)
            const isSentByMe = parseInt(item?.to_user_id) === otherId || (parseInt(item?.from_user_id) !== otherId && !isNaN(parseInt(item?.from_user_id)))
            const senderName = isSentByMe ? 'You' : (selectedContactDetail?.name || selectedContactDetail?.rd_name || 'Them')
            const timeOnly = formatTimeOnly(item.timezone || item.created_at)
            const timeLabel = `${senderName} · ${timeOnly}`

            const currentDateKey = getDateKey(item.timezone || item.created_at)
            const prevDateKey = index > 0 ? getDateKey(messages[index - 1].timezone || messages[index - 1].created_at) : null
            const showDateDivider = currentDateKey && currentDateKey !== prevDateKey

            return (
                <Fragment key={index}>
                    {showDateDivider && (
                        <div className='chat-date-divider text-center my-1 w-100'>
                            <span>
                                {formatDateDivider(item.timezone || item.created_at)}
                            </span>
                        </div>
                    )}
                    <div
                        ref={(el) => (ps.current[index] = el)}
                        className={classnames("chat", {
                            "chat-left": !isSentByMe
                        })}
                    >
                        <div className="chat-body">
                            {/* Sender Name + Time ABOVE Bubble */}
                            <div className={classnames('chat-meta-top mb-25', {
                                'text-right': isSentByMe,
                                'text-left': !isSentByMe
                            })}>
                                <span>
                                    {timeLabel}
                                </span>
                            </div>

                            {/* Message Content */}
                            {item.media ? (
                                <div className="chat-content media-file">
                                    {item.message_type === "img" && (
                                        <div>
                                            <img src={item.media} height="200" title={item.file_name} alt={item.file_name}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "pdf" && (
                                        <div>
                                            <File size={100} style={{color: '#56B6FF'}}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "doc" && (
                                        <div>
                                            <File size={100} style={{color: '#56B6FF'}}/>
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                               style={{textDecoration: "underline"}}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="chat-content">
                                    <div dangerouslySetInnerHTML={{__html: item.message}}></div>
                                </div>
                            )}
                        </div>
                    </div>
                </Fragment>
            )
        })
    }

    const renderMassMessageContent = () => {
        const detail = brandChatStoreSlice?.massMessageDetail
        const selectedUserBrandChatLoading = brandChatStoreSlice?.selectedUserBrandChatLoading
        if (selectedUserBrandChatLoading) {
            return (
                <div className="d-flex align-items-center justify-content-center p-5">
                    <Spinner color="primary" /> <span className="ml-2">Loading broadcast detail...</span>
                </div>
            )
        }
        const messageHtml = detail?.message || selectedContactDetail?.last_message || ''
        const recipients = detail?.recipients || []
        const filteredRecipients = recipients.filter(r => (r?.name || '').toLowerCase().includes(recipientSearch.toLowerCase()))
        const rawTitle = (detail?.name || detail?.title || selectedContactDetail?.name || '').trim()
        const isSelectedManual = rawTitle.toLowerCase().includes('selected')
        const categoryName = rawTitle.replace(/^Mass Message to\s+/i, '').trim() || 'All RDs'
        const totalCount = detail?.total_recipients || recipients.length || 0

        return (
            <div className="p-3" style={{ maxWidth: '850px', margin: '0 auto' }}>
                <Card className="shadow-sm mb-3">
                    <CardBody className="p-3">
                        <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                            <div className="d-flex align-items-center">
                                <Send size={18} className="text-primary mr-1" />
                                <h5 className="mb-0 font-weight-bold">Broadcast Message Content</h5>
                            </div>
                            <span className="badge badge-light-secondary px-2 py-1">
                                {detail?.created_at || selectedContactDetail?.created_at || 'Sent recently'}
                            </span>
                        </div>
                        <div
                            className="message-html-container p-2 bg-light rounded"
                            dangerouslySetInnerHTML={{ __html: messageHtml }}
                            style={{ fontSize: '0.95rem', lineHeight: '1.6' }}
                        />
                    </CardBody>
                </Card>

                {isSelectedManual ? (
                    <Card className="shadow-sm mb-3">
                        <CardBody className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom flex-wrap" style={{ gap: '10px' }}>
                                <div className="d-flex align-items-center">
                                    <Users size={18} className="text-primary mr-1" />
                                    <h5 className="mb-0 font-weight-bold">
                                        Selected Recipients ({totalCount} RDs)
                                    </h5>
                                </div>
                                {recipients.length > 6 && (
                                    <div style={{ width: '220px' }}>
                                        <Input
                                            type="text"
                                            placeholder="Search recipients..."
                                            bsSize="sm"
                                            value={recipientSearch}
                                            onChange={e => setRecipientSearch(e.target.value)}
                                            style={{ borderRadius: '6px', fontSize: '12px' }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div
                                style={{
                                    maxHeight: '380px',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    paddingRight: '6px'
                                }}
                            >
                                <Row>
                                    {filteredRecipients.map((r, i) => (
                                        <Col key={i} md={4} sm={6} className="mb-2">
                                            <div className="d-flex align-items-center p-2 rounded border bg-white shadow-xs h-100">
                                                <Link to={`/dashboard/brands/nutritions/${r.user_id}`} title="View RD profile">
                                                    <CustomAvatar
                                                        name={r.name}
                                                        img={r.profile_image}
                                                        imgHeight='44'
                                                        imgWidth='44'
                                                        className="mr-2 cursor-pointer avatar-img-fit-contain"
                                                    />
                                                </Link>
                                                <div className="text-truncate flex-grow-1 min-w-0">
                                                    <Link to={`/dashboard/brands/nutritions/${r.user_id}`} className="text-dark font-weight-bold d-block text-truncate">
                                                        {r.name}
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                    {filteredRecipients.length === 0 && (
                                        <Col xs={12} className="text-center py-3 text-muted">
                                            No matching recipients found.
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                ) : (
                    <Card className="shadow-sm mb-3">
                        <CardBody className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-2 pb-1 border-bottom">
                                <div className="d-flex align-items-center">
                                    <Users size={18} className="text-primary mr-1" />
                                    <h5 className="mb-0 font-weight-bold">Recipient Category</h5>
                                </div>
                                <span className="badge badge-light-primary px-2 py-1 font-weight-bold" style={{ fontSize: '12px' }}>
                                    {totalCount} Total RDs
                                </span>
                            </div>
                            <div className="d-flex align-items-center p-2 rounded border bg-light" style={{ gap: '12px' }}>
                                <div
                                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                                    style={{
                                        width: '44px',
                                        height: '44px',
                                        borderRadius: '10px',
                                        backgroundColor: '#eef2ff',
                                        color: '#4f46e5',
                                        border: '1.5px solid #e0e7ff'
                                    }}
                                >
                                    <Users size={22} />
                                </div>
                                <div>
                                    <span className="text-muted small d-block">Target Audience:</span>
                                    <h6 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '15px' }}>
                                        {categoryName}
                                    </h6>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                )}

                <Alert color="info" className="d-flex align-items-center mb-0">
                    <Info size={18} className="mr-2 flex-shrink-0" />
                    <div style={{ fontSize: '0.85rem' }}>
                        <strong>1:1 Reply Branching Active:</strong> This is a broadcast send. When any dietitian replies, their response automatically creates a direct 1:1 conversation in your Inbox.
                    </div>
                </Alert>
            </div>
        )
    }

    const handleStartConversation = () => {
        if (!userSidebarLeft && window.innerWidth <= 1200) {
            handleSidebar()
        }
    }

    const ChatWrapper = selectedContactDetail && selectedUserBrandChat ? PerfectScrollbar : 'div'

    const handleCheckAll = (e) => {
        const checked = e.target.checked
        const list = [...selectedBroadcastContacts]
        const names = [...selectedRds]
        if (checked) {
            setCheckAllVal(true)
            for (const item of broadCastRDsList) {
                if (!list.includes(item.user_id)) {
                    list.push(item.user_id)
                    names.push(item.name)
                }
            }
            setSelectedBraodcastContacts(list)
            setSelectedRds(names)
        } else {
            setCheckAllVal(false)
            setSelectedBraodcastContacts([])
            setSelectedRds([])
        }
    }

    const handleSelectedFolder = (folderId, folderTitle) => {
        setBackToFav(true)
        setShowFav(false)
        setFavFolderId(folderId)
        setFavFolderTitle(folderTitle)
        setBroadCastRDsListLoading(true)
        setSelectedBraodcastContacts([])
        setBroadCastRDsList([])
        setFavFolderList(null)
        dispatch({type: "CLEAR_FAV_FOLDERS_LIST"})
        const API_URL = process.env.REACT_APP_BASEURL
        dispatch(getFavoriteRDProfiles(true, `${API_URL}brand/favorites-profiles?folder_id=${folderId}&list=all`, ''))
    }

    const handleGroupChange = (category, event, value) => {
        dispatch(rdGroupListReset())
        setBroadCastRDsList([])
        setSelectedBraodcastContacts([])
        const label = value?.label || ''
        if (label) {
            setSelectedGroupLabels(prev => {
                if (event.target.checked) {
                    return [...prev.filter(l => l !== label), label]
                } else {
                    return prev.filter(l => l !== label)
                }
            })
        }
        setGroupData(prevGroupData => {
            const newGroupData = {...prevGroupData}
            const index = newGroupData[category].indexOf(value?.id)
            if (index === -1) {
                newGroupData[category] = [...newGroupData[category], value?.id]
            } else {
                newGroupData[category] = [
                    ...newGroupData[category].slice(0, index),
                    ...newGroupData[category].slice(index + 1)
                ]
            }
            return newGroupData
        })
    }

    useEffect(() => {
        if (groupData.speciality.length > 0 || groupData.industry.length > 0 || groupData.characteristics.length > 0) {
            dispatch(rdGroupList({
                speciality: groupData.speciality,
                industry: groupData.industry,
                personal_attr: groupData.characteristics,
                filter: 'list'
            }))
        }
    }, [groupData])

    const { setMassMessageTrigger } = props

    useEffect(() => {
        if (setMassMessageTrigger) {
            setMassMessageTrigger(() => {
                setIsOpenBroadcastModal(true)
                setSelectedBraodcastContacts([])
                setCheckAllVal(false)
                setSelectedRds([])
                getRdList('my_rds')
            })
        }
    }, [setMassMessageTrigger])

    return (
        <Fragment>
            <div className="chat-app-window w-100 chat-brand">
                <div className={classnames("start-chatArea-parent", {
                    "d-none": !!selectedContactDetail
                })}>
                    <div className="chat-navbar">
                        <header className="chat-header d-flex align-items-center justify-content-end px-1">
                            <div className="ml-auto d-flex align-items-center">
                                <Button.Ripple
                                    color='primary'
                                    id="send-mass-msg-empty-state"
                                    title="Send a mass message"
                                    size='sm'
                                    className='d-inline-flex align-items-center ml-auto'
                                    style={{ height: '34px', borderRadius: '8px', padding: '0 12px', fontSize: '12px' }}
                                    onClick={() => {
                                        setIsOpenBroadcastModal(true)
                                        setSelectedBraodcastContacts([])
                                        setCheckAllVal(false)
                                        setSelectedRds([])
                                        getRdList('my_rds')
                                    }}
                                >
                                    <Send size={14} className="mr-50"/>
                                    <span>Mass Message</span>
                                </Button.Ripple>
                            </div>
                        </header>
                    </div>
                    <div
                        className={classnames("start-chat-area", {
                            "d-none": !!selectedContactDetail
                        })}>
                        {/* <div className='start-chat-area'> */}
                        <div className="start-chat-icon mb-1">
                            <MessageSquare/>
                        </div>
                        <h4 className="sidebar-toggle start-chat-text text-center">
                            <div>Select a RD First to Start Chat.</div>
                            <button className="d-sm-none btn btn-link font-medium-3 text-underline" onClick={handleStartConversation}>
                                Tap Here
                            </button>
                        </h4>
                    </div>
                </div>
                <div
                    className={classnames("active-chat", {
                        "d-none": selectedContactDetail === null
                    })}
                >
                    <div className="chat-navbar">
                        <header className="chat-header justify-content-between">
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="sidebar-toggle d-block d-lg-none mr-1">
                                    <button onClick={handleSidebar} className='btn btn-link p-0'>
                                        <ChevronLeft size={21}/>
                                    </button>
                                </div>
                                {selectedContactDetail && (
                                    selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                        <div className='d-flex align-items-center text-body ml-25 overflow-hidden'>
                                            <div
                                                className="d-flex align-items-center justify-content-center flex-shrink-0 mr-50"
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#eef2ff',
                                                    color: '#4f46e5',
                                                    border: '1.5px solid #e0e7ff',
                                                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                                                }}
                                                title="Mass Message Broadcast"
                                            >
                                                <Users size={18} />
                                            </div>
                                            <div className='d-flex flex-column justify-content-center overflow-hidden'>
                                                <h6 className='mb-0 font-weight-bold text-truncate' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                    {selectedContactDetail?.name || 'Mass Message'}
                                                </h6>
                                                {getHeaderSubtitle()}
                                            </div>
                                        </div>
                                    ) : (
                                        <Link
                                            to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                            className='d-flex align-items-center text-body ml-25 overflow-hidden'
                                            title='View RD profile'
                                        >
                                            <CustomAvatar
                                                name={selectedContactDetail?.name || selectedContactDetail?.rd_name}
                                                img={selectedContactDetail?.profile_image || selectedContactDetail?.profile_img}
                                                imgHeight='36'
                                                imgWidth='36'
                                                className='mr-50 flex-shrink-0'
                                            />
                                            <div className='d-flex flex-column justify-content-center overflow-hidden'>
                                                <h6 className='mb-0 font-weight-bold text-truncate' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                    {selectedContactDetail?.name || selectedContactDetail?.rd_name}
                                                </h6>
                                                {getHeaderSubtitle()}
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>

                            {/* Header Actions — Right Side */}
                            {selectedContactDetail && !(selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass') && (
                                <div className='d-flex align-items-center ml-1' style={{ gap: '6px' }}>
                                    {/* Profile Button — desktop view */}
                                    <Link
                                        to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                        className='btn btn-outline-secondary btn-icon btn-sm d-none d-md-inline-flex align-items-center justify-content-center chat-header-action-btn'
                                        title='View Profile'
                                        style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                    >
                                        <User size={16} />
                                    </Link>

                                    {/* Archive / Unarchive Button — desktop view */}
                                    {activeTab === 'archive' ? (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Unarchive this thread?',
                                                    text: 'It will be moved back to your Inbox.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Unarchive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(unarchiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('inbox')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <UnarchiveIcon size={14} className='mr-25' />
                                            <span>Unarchive</span>
                                        </Button>
                                    ) : (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <ArchiveIcon size={14} className='mr-25' />
                                            <span>Archive</span>
                                        </Button>
                                    )}

                                    {/* 3-Dot Dropdown Menu */}
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            color='outline-secondary'
                                            size='sm'
                                            className='btn-icon chat-header-action-btn d-flex align-items-center justify-content-center'
                                            style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                        >
                                            <MoreVertical size={16} />
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {/* Mobile-only responsive fallbacks */}
                                            <DropdownItem
                                                tag={Link}
                                                to={`/dashboard/brands/nutritions/${selectedContactDetail?.chat_user}`}
                                                className='d-flex d-md-none align-items-center'
                                            >
                                                <User size={14} className='mr-50' />
                                                <span>View Profile</span>
                                            </DropdownItem>
                                            {activeTab === 'archive' ? (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Unarchive this thread?',
                                                            text: 'It will be moved back to your Inbox.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Unarchive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(unarchiveConversation(selectedContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('inbox')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <UnarchiveIcon size={14} className='mr-50' />
                                                    <span>Unarchive Thread</span>
                                                </DropdownItem>
                                            ) : (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Archive this thread?',
                                                            text: 'It will be moved to your Archive tab.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Archive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('archive')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <ArchiveIcon size={14} className='mr-50' />
                                                    <span>Archive Thread</span>
                                                </DropdownItem>
                                            )}

                                            {/* Non-redundant action: Mark as Unread */}
                                            <DropdownItem
                                                className='d-flex align-items-center'
                                                onClick={() => {
                                                    dispatch(markConversationUnread(selectedContactDetail?.chat_user))
                                                    toast.success('Conversation marked as unread')
                                                }}
                                            >
                                                <Mail size={14} className='mr-50' />
                                                <span>Mark as Unread</span>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            )}
                        </header>
                    </div>
                    <ChatWrapper containerRef={ref => {
                        chatArea.current = ref
                    }}
                                 className="user-chats"
                                 options={{wheelPropagation: false}}
                    >
                        <div className="chats">
                            {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                                renderMassMessageContent()
                            ) : (
                                <Fragment>
                                    {brandChatStoreSlice?.selectedUserBrandChatLoading ? (
                                        /* Skeleton loader — alternating left/right bubbles */
                                        <div className="chat-skeleton-loader px-1 py-1">
                                            {[true, false, true, false, true].map((isRight, i) => (
                                                <div key={i} className={`chat-skeleton-row ${isRight ? 'right' : 'left'}`}>
                                                    {!isRight && <div className="skeleton-avatar-sm" />}
                                                    <div className="skeleton-bubble" style={{width: `${45 + (i % 3) * 15}%`}} />
                                                    {isRight && <div className="skeleton-avatar-sm" />}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <Fragment>{renderChats()}</Fragment>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </ChatWrapper>
                    {selectedContactDetail?.is_mass_group || selectedContactDetail?.user_type === 'mass' ? (
                        <div className="chat-app-form d-flex align-items-center justify-content-center p-2 bg-light border-top text-muted" style={{ minHeight: '60px' }}>
                            <Info size={16} className="mr-1 text-info" />
                            <span style={{ fontSize: '0.85rem' }}>Broadcast log view (read-only). Direct replies from RDs appear in your Inbox.</span>
                        </div>
                    ) : (
                    <div className="bg-white d-block chat-bottom-wrapper">
                        {fileUploadError &&
                            <div className="validation-err ml-1">{allowedFilesErrorMessages().IMAGE_AND_FILES} </div>}
                        {!brandChatStoreSlice?.selectedUserBrandChatLoading && showFollowUp && !isThreadArchived && (
                            <div className="d-flex flex-wrap align-items-center justify-content-between chat-followup-banner">
                                <div className='d-flex align-items-center' style={{gap: '8px'}}>
                                    <Clock size={16} className='flex-shrink-0' style={{ color: '#7c2d12' }} />
                                    <span className='banner-text'>
                                        {`You replied ${daysSince === 1 ? '1 day' : `${daysSince} days`} ago — still waiting on ${selectedContactDetail?.name || selectedContactDetail?.rd_name || 'nutritionist'}.`}
                                    </span>
                                </div>
                                <div className='d-flex align-items-center' style={{gap: '8px'}}>
                                    {activeTab !== 'archive' && (
                                        <button
                                            type='button'
                                            className='btn btn-archive-banner'
                                            onClick={() => {
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            Archive
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                        <Form className="chat-app-form" onSubmit={(e) => handleSendMsg(e)}>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <Editor
                                        editorState={msgEditorState}
                                        placeholder="Write a message..."
                                        onEditorStateChange={(e) => {
                                            setMsgEditorState(e)
                                            const contentState = e.getCurrentContent()
                                            if (contentState.hasText()) {
                                                setMsg(draftToHtml(convertToRaw(e.getCurrentContent())))
                                            } else {
                                                setMsg('')
                                            }
                                        }}
                                        toolbar={{
                                            options: ['inline', 'list', 'link'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline']
                                            },
                                            list: {
                                                options: ['unordered', 'ordered']
                                            },
                                            link: {
                                                popupClassName: 'msg-editor-link-and-img',
                                                showOpenOptionOnHover: false
                                            }
                                        }}
                                        editorClassName='msg-editor'
                                        stripPastedStyles={true}
                                    />
                                </Col>
                                <Col xs={12} lg={12} className="d-flex justify-content-between align-items-center mt-1 pt-75 border-top">
                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <Label
                                            className="btn-chat-icon-action mb-0 cursor-pointer"
                                            htmlFor="attach-doc"
                                            title="Attach file (PDF, Image, Doc)"
                                        >
                                            <Paperclip size={18} />
                                            <input type="file"
                                                id="attach-doc"
                                                accept=".pdf, .png, .jpg, .jpeg, .doc, .docx, .xlsx, .xls"
                                                onChange={changeHandler}
                                                hidden={true}
                                                disabled={sendMsgLoader}
                                            />
                                        </Label>

                                        {/* Template Icon Button & Animated Menu with Click-Outside Ref */}
                                        <div ref={templateBarRef} className="d-flex align-items-center" style={{ gap: '6px' }}>
                                            <button
                                                type="button"
                                                className={classnames("btn-chat-icon-action", { active: showTemplateBar })}
                                                title="Message Templates"
                                                onClick={() => setShowTemplateBar(!showTemplateBar)}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                                                    <line x1="8" y1="4" x2="8" y2="20"></line>
                                                    <line x1="12" y1="9" x2="18" y2="9"></line>
                                                    <line x1="12" y1="15" x2="18" y2="15"></line>
                                                </svg>
                                            </button>

                                            {/* Animated 2-Tag Option Menu with Cross Icon */}
                                            {showTemplateBar && (
                                                <div className="chat-template-action-bar">
                                                    <button
                                                        type="button"
                                                        className="btn-template-tag"
                                                        onClick={() => {
                                                            setIsOpenTempleteModal(false)
                                                            setOpenTemplatesModal(true)
                                                            setTemplateType('message')
                                                            setShowTemplateBar(false)
                                                        }}
                                                    >
                                                        <FileText size={13} />
                                                        <span>Templates</span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn-template-save-tag"
                                                        onClick={() => {
                                                            setOpenTemplatesModal(false)
                                                            setIsOpenTempleteModal(true)
                                                            setTemplateType('message')
                                                            setShowTemplateBar(false)
                                                        }}
                                                        disabled={sendMsgLoader || msg.length === 0}
                                                    >
                                                        <Plus size={13} />
                                                        <span>Save Template</span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn-template-close-tag"
                                                        onClick={() => setShowTemplateBar(false)}
                                                        title="Close"
                                                    >
                                                        <X size={13} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {questate.inQueFilePreview && (
                                            <div className="badge badge-light-primary d-flex align-items-center py-50 px-75 rounded-pill">
                                                {selectedFile?.type === "application/pdf" ? (
                                                    <FileText size="14" className="mr-50 text-primary" />
                                                ) : (
                                                    <Image size="14" className="mr-50 text-primary" />
                                                )}
                                                <span className="text-truncate mr-50 font-weight-bold" style={{ maxWidth: '140px', fontSize: '12px' }}>
                                                    {selectedFile?.name || 'Attached file'}
                                                </span>
                                                <X size={14}
                                                   className="cursor-pointer text-danger ml-25"
                                                   title="Remove attachment"
                                                   onClick={() => {
                                                       setQueState({ inQueFilePreview: '', inQueFile: '' })
                                                       setSelectedFile(null)
                                                   }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <Button
                                            color="primary"
                                            id="send-message"
                                            disabled={sendMsgLoader || msg.length === 0}
                                            size="sm"
                                            className="d-flex align-items-center"
                                        >
                                            {sendMsgLoader ? (
                                                <Spinner style={{ height: '14px', width: '14px' }} />
                                            ) : (
                                                <Fragment>
                                                    <Send size={15} className="mr-50" />
                                                    <span>Send</span>
                                                </Fragment>
                                            )}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    )}
                </div>
            </div>

            <Modal isOpen={isOpenBroadcastModal} size='xl'>
                <ModalHeader>Send a mass message</ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <FormGroup className='mb-2'>
                        <div className="d-flex justify-content-between flex-wrap">
                            <Label htmlFor='coupon-code'>Write a Message</Label>
                        </div>
                        <Editor editorState={massMsgEditorState} onEditorStateChange={(e) => {
                            setMassMsgEditorState(e)
                            const contentState = e.getCurrentContent()
                            if (contentState.hasText()) {
                                setBroadcastMessage(draftToHtml(convertToRaw(e.getCurrentContent())))
                            } else {
                                setBroadcastMessage('')
                            }
                        }}
                                toolbar={{
                                    options: ['inline', 'list', 'link', 'image'],
                                    inline: {
                                        options: ['bold', 'italic', 'underline']
                                    },
                                    list: {
                                        options: ['unordered', 'ordered']
                                    },
                                    link: {
                                        popupClassName: 'msg-editor-link-and-img',
                                        showOpenOptionOnHover: false
                                    },
                                    image: {
                                        popupClassName: 'msg-editor-link-and-img',
                                        defaultSize: {
                                            height: '500',
                                            width: '500'
                                        }
                                    }
                                }}
                                editorClassName='msg-editor'
                                stripPastedStyles={true}
                        />
                    </FormGroup>
                    <FormGroup className='mb-2'>
                        <div className='text-right border-bottom pb-1'>
                            <button className='btn btn-primary mr-1 btn-sm'
                                    onClick={() => {
                                        setOpenTemplatesModal(false)
                                        setIsOpenTempleteModal(true)
                                        setTemplateType('mass')
                                    }} disabled={broadcastMessage.length === 0}
                            >
                                Save Templates
                            </button>
                            <button className='btn btn-success btn-sm'
                                    onClick={() => {
                                        setIsOpenTempleteModal(false)
                                        setOpenTemplatesModal(true)
                                        setTemplateType('mass')
                                    }}
                            >
                                View Templates
                            </button>
                        </div>
                    </FormGroup>
                    <FormGroup className='border-bottom pb-1'>
                        <Row>
                            <Col xs={12} lg={2}>
                                {broadCastRDsList.length > 0 && showGroups === false && (
                                    <CustomInput
                                        key="3"
                                        type='checkbox'
                                        id="check-all"
                                        label="Select All"
                                        name="check_all"
                                        onChange={handleCheckAll}
                                        checked={checkAllVal}
                                    />
                                )}
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="1"
                                    type='radio'
                                    id="my-rds"
                                    label="My RDs"
                                    onChange={() => getRdList('my_rds')}
                                    className="mr-2"
                                    name="selectRDs"
                                    checked={selectedRadio === 'my_rds'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="2"
                                    type='radio'
                                    id="all-rds"
                                    label="All RDs"
                                    onChange={() => getRdList('all_rds')}
                                    className="mr-2"
                                    name="selectRDs"
                                    checked={selectedRadio === 'all_rds'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="3"
                                    type='radio'
                                    id="from-favourites"
                                    label="From Favorites"
                                    onChange={() => getRdList('favourites')}
                                    name="selectRDs"
                                    checked={selectedRadio === 'favourites'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                            <Col xs={12} lg={2}>
                                <CustomInput
                                    key="3"
                                    type='radio'
                                    id="groups"
                                    label="Filter"
                                    onChange={() => getRdList('groups')}
                                    name="selectRDs"
                                    checked={selectedRadio === 'groups'}
                                    disabled={broadCastRDsListLoading}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    {showFav && (
                        <div className="p-1 bg-light">
                            <span>
                                <strong>Select Folder</strong>
                            </span>
                        </div>
                    )}
                    {backToFav && (
                        <div className="p-1 bg-light d-flex justify-content-between">
                            <button className="text-primary d-flex align-items-center cursor-pointer ml-1 btn p-0" onClick={() => getRdList('favourites')}>
                                {!broadCastRDsListLoading && (
                                    <>
                                        <ArrowLeftCircle size={15}/> <strong style={{marginLeft: '3px'}}>Back</strong>
                                    </>
                                )}
                            </button>
                            <span><strong>{favFolderTitle}</strong></span>
                        </div>
                    )}
                    <div className="rds-list-message-modal">
                        <Row>
                            {showGroups && (
                                <>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Speciality:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.speciality?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`speciality-${index}`}
                                                                 id={`speciality-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('speciality', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Industry:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.industry?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`industry-${index}`}
                                                                 id={`industry-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('industry', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <FormGroup>
                                            <h6 className='filter-title bg-light p-1 font-weight-bold'>Personal Characteristics:</h6>
                                            <div style={{height: '250px', overflow: 'auto'}}>
                                                {brandsDashboardStoreSlice?.goalsAttributes?.personal_attributes?.map((brand, index) => (
                                                    <CustomInput key={index}
                                                                 type='checkbox'
                                                                 className="mx-2 mb-1"
                                                                 name={`personal-characteristics-${index}`}
                                                                 id={`personal-characteristics-${index}`}
                                                                 label={brand.label}
                                                                 onChange={(e) => handleGroupChange('characteristics', e, brand)}
                                                                 disabled={rdGroupListLoading}
                                                    />
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    {broadCastRDsList.length > 0 && (
                                        <Col md={12}>
                                            <div className='bg-light p-1 mt-2 mb-2'>
                                                <strong>Total RD's Found: {broadCastRDsList.length}</strong>
                                            </div>
                                        </Col>
                                    )}
                                </>
                            )}
                            {(broadCastRDsListLoading || rdGroupListLoading) &&
                                <Col md={12} className="text-center">
                                    <Spinner color="primary" style={{width: '16px', height: '16px'}}/> Please wait...
                                </Col>
                            }
                            {!broadCastRDsListLoading && broadCastRDsList?.map((item, index) => (
                                <Col className="col-md-3" key={index}>
                                    <Card className={classnames({
                                        'ecommerce-card': true,
                                        'mb-1': true,
                                        'border-1px-white': (!selectedBroadcastContacts?.includes(item.user_id)),
                                        'cursor-pointer': true,
                                        'border-1px-purple': selectedBroadcastContacts?.includes(item.user_id)
                                    })} key={item.user_id} onClick={() => handleSelectBroadCastingContact(item)}>
                                        <CardBody className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <CustomInput id={`user-checkbox-${index}`}
                                                             type='checkbox'
                                                             checked={selectedBroadcastContacts?.includes(item.user_id)}
                                                             className="mr-1"
                                                             disabled={true}
                                                />
                                                <CustomAvatar
                                                    name={item?.name || item?.rd_name}
                                                    img={item?.profile_img || item?.profile_image}
                                                    imgHeight='36'
                                                    imgWidth='36'
                                                />
                                                <div>
                                                    <h5 className='mb-0 ml-1 text-break'> {item.name}</h5>
                                                    {item.is_favorite &&
                                                        <p className='mb-0 ml-1 folder-name-at-broadcast-rds'>
                                                            {item?.folder_title?.length > 10 ? ` ${item?.folder_title.substring(0, 10)}...` : item?.folder_title}
                                                        </p>}
                                                </div>
                                            </div>
                                            {item.is_favorite && <Heart color="red" size={16}/>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                            {favFolderList && favFolderList.map((item, index) => (
                                <Col xs={12} md={3}>
                                    <Card key={index} className="cursor-pointer" onClick={() => handleSelectedFolder(item.id, item.folder_name)}>
                                        <CardBody className=" fav-folders">
                                            <div className="align-items-center">
                                                <h5 className='mb-0'>
                                                    {item?.folder_name.length > 20 ? `${item?.folder_name.substring(0, 20)}...` : item?.folder_name}
                                                </h5>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        {broadCastRDsListLoading === false && broadCastRDsList.length === 0 && showFav === false && showGroups === false && (
                            <div className="text-center">
                                <strong>Sorry! No data found.</strong>
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' outline onClick={() => {
                        setIsOpenBroadcastModal(!isOpenBroadcastModal)
                        setSelectedBraodcastContacts([])
                        setCheckAllVal(false)
                        setBroadCastRDsList([])
                        setMassMsgEditorState(null)
                        setBroadcastMessage('')
                        dispatch({type: 'CLEAT_BROADCAST_LIST'})
                    }}>
                        Cancel
                    </Button>
                    <Button color='primary' disabled={selectedBroadcastContacts.length === 0 || broadcastMessage === ''}
                            onClick={() => {
                                setShowPreviewModal(true)
                            }}>
                        Send
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Mass messages preview modal*/}
            <Modal isOpen={showPreviewModal} className='modal-lg'>
                <ModalHeader>Confirmation</ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <Alert color="success" isOpen={broadCastResStatus}>
                        <div className='alert-body'>
                            {broadCastResMsg}
                        </div>
                    </Alert>

                    <FormGroup className='mb-2'>
                        <Label htmlFor='coupon-code'><strong>Message</strong></Label>
                        <div dangerouslySetInnerHTML={{__html: broadcastMessage}} style={{minHeight: '150px'}}
                             className="bg-light p-1 border text-break"></div>
                    </FormGroup>
                    <FormGroup className='mb-2'>
                        <Label htmlFor='coupon-code'><strong>To ({selectedRds.length})</strong></Label>
                        <div className="rds-list-message-modal">
                            {selectedRds.map((name) => (
                                <span className="badge badge-primary mb-1 mr-1">{name}</span>
                            ))}
                        </div>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' outline onClick={() => setShowPreviewModal(false)}
                            disabled={broadCastSendLoader}>
                        Cancel
                    </Button>
                    <Button color='primary' onClick={() => sendBroadcastMessage()}
                            disabled={broadCastSendLoader || broadCastResStatus}>
                        {broadCastSendLoader ? <Spinner style={{height: '14px', width: '14px'}}/> : "Send"}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* --- Template Modal --- */}
            <MsgTemplates showSaveModal={isOpenTempleteModal}
                          template={templateType === 'message' ? msg : broadcastMessage}
                          closeModal={() => {
                              setIsOpenTempleteModal(false)
                              setOpenTemplatesModal(false)
                              setTemplateType(null)
                          }}
                          templateType={templateType}
                          showTemplatesModal={openTemplatesModal}
                          applyTemplate={(data) => {
                              appendTemplate(data)
                          }}
            />
        </Fragment>
    )
}

ChatLog.propTypes = {
    handleUser: PropTypes.func.isRequired,
    handleUserSidebarRight: PropTypes.func.isRequired,
    handleSidebar: PropTypes.func.isRequired,
    store: PropTypes.object,
    userSidebarLeft: PropTypes.bool.isRequired,
    user: PropTypes.object,
    selectedUserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedUserBrandChat: PropTypes.object,
    selectedContactDetail: PropTypes.object,
    currentUser: PropTypes.object
}

export default memo(ChatLog)